import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { bulkDeleteHouseConsignments } from '../api/bulkDeleteHouseConsignments'

function useBulkDeleteHouseConsignments(consignmentId: number) {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: bulkDeleteHouseConsignments,
    onSuccess: async () => {
      await queryClient.invalidateQueries(QueryKeys.houseConsignment.all(consignmentId))
      await queryClient.invalidateQueries(QueryKeys.consignment.summary(consignmentId))
    },
  })

  const { mutateAsync, isLoading } = mutation

  const bulkDelete = (ids: number[]) => mutateAsync(ids)

  return {
    bulkDelete,
    isBulkDeleting: isLoading,
  }
}

export default useBulkDeleteHouseConsignments
